import { config } from '../config';

export function getServiceLogs() {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/hq/service-logs`,
  };
}

export function createServiceLog(data) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/api/hq/service-logs/` + data.memberId,
    data: data,
  };
}

export function getServiceLogsByMemberId(id) {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/hq/service-logs/${id}`,
  };
}

export function getDatadogLogsByMemberId(id) {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/hq/service-logs/datadog-logs?MemberId=${id}`,
    data: {
      FirebaseUid: 0,
      MemberId: id,
    },
  };
}

export function getPaginatedServiceLogs(id, limit, page) {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/service-logs/member/logs?MemberId=${id}&Limit=${limit}&Page=${page}`,
  };
}

export function getSupportNotes() {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/support-notes`,
  };
}

export function getSupportFavorites() {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/support-favorites`,
  };
}

export function getLicenseCountHQ(firebaseUid) {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/legacy-license-service/get-license-counts/${firebaseUid}`,
  };
}

export function removeWalletByFirebaseUid(firebaseUid) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/api/wallet-service/removeWalletByFirebaseUid/${firebaseUid}`,
  };
}

export function fetchMemberWalletETHInfo(id) {
  //TODO - Get Backend Endpoint Created At This Url
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/wallet-service/get-wallet-details/${id}/ETH`,
  };
}

export function getMemberWalletsDataLegacyHQ(firebaseUid) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/api/legacy-wallet/wallets/${firebaseUid}/get-member-wallets-data`,
  };
}

export function setMemberAsFavorite(id, groupId = 1) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/api/support-favorites/toggle`,
    data: {
      groupId,
      memberId: id,
    },
  };
}

export function deleteMemberAsFavorite(id) {
  return {
    method: 'DELETE',
    url: `${config.core.supportToolsServiceUrl}/api/support-favorites/${id}`,
  };
}

export function deleteMultiFavorites(ids) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/v1.0/hq/favorites/delete-multiple`,
    data: ids,
  };
}

export function checkIfUserIsFavorited(id, groupId = 1, extras = {}) {
  return {
    method: 'POST',
    url: `${config.core.supportToolsServiceUrl}/api/support-favorites/check`,
    data: {
      groupId,
      memberId: id,
    },
    extras: extras,
  };
}

export function getFavoriteUsers() {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/api/support-favorites/list`,
  };
}

export function updateLineItems(memberId, invoiceId, lineItems) {
  return {
    method: 'PUT',
    url: `${config.core.supportToolsServiceUrl}/api/shopping/invoices/${invoiceId}/update-line-items/${memberId}`,
    data: {
      reason: 'Update Invoice',
      lineItems,
    },
  };
}

export function getSystemConfigurations() {
  return {
    method: 'GET',
    url: `${config.core.supportToolsServiceUrl}/v1.0/system-configurations`,
  };
}

export function updateSystemConfigurations(data) {
  return {
    method: 'PUT',
    url: `${config.core.supportToolsServiceUrl}/v1.0/system-configurations`,
    data,
  };
}
